<template>
  <v-navigation-drawer
    :value="drawer"
    app
    temporary
    @input="$emit('input', $event)"
  >
    <v-container>
      <v-row>
        <v-col cols="12" class="px-0 pb-0 pt-0">
          <h3 class="text-center mb-2">Filtrar</h3>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" class="mt-3">
          <v-select
            v-model="selectedStatus"
            :items="status"
            label="Status"
            dense
            multiple
          >
            <template v-slot:prepend-item>
              <v-list-item
                ripple
                @click="toggle"
              >
                <v-list-item-action>
                  <v-icon :color="selectedStatus.length > 0 ? 'primary' : ''">{{ icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Selecionar todos</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
            <template v-slot:selection="{ item }">
              <v-chip small :color="statusColor(item)">
                <span>{{ item }}</span>
              </v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'Filters'
    },
    drawer: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedStatus: ['Em Progresso', 'Solicitar Revisão', 'Solicitar Correção', 'Publicado', 'Cancelado'],
    status: ['Em Progresso', 'Solicitar Revisão', 'Solicitar Correção', 'Publicado', 'Cancelado'],
  }),
  watch: {
    selectedStatus(value) {
      this.saveLocalStatus();
      this.$emit('filtraStatus', value);
    }
  },
  computed: {
    allStatus () {
      return this.selectedStatus.length === this.status.length
    },
    someStatus () {
      return this.selectedStatus.length > 0 && !this.allStatus
    },
    icon () {
      if (this.allStatus) return 'fa-check-square'
      if (this.someStatus) return 'fa-minus-square'
      return 'far fa-square'
    },
  },
  methods: {
    statusColor(status) {
      if (status === 'Em Progresso') return 'primary';
      else if (status === 'Solicitar Revisão') return 'warning';
      else if (status === 'Solicitar Correção') return 'error';
      else if (status === 'Cancelado') return 'secondary';
      else return 'success';
    },
    loadLocalStatus() {
      if (localStorage.getItem(this.name)) {
        this.selectedStatus = JSON.parse(localStorage.getItem(this.name));
        this.$emit('filtraStatus', this.selectedStatus);
      }
    },
    saveLocalStatus() {
      localStorage.setItem(this.name, JSON.stringify(this.selectedStatus));
    },
    toggle () {
      this.$nextTick(() => {
        if (this.allStatus) {
          this.selectedStatus = []
        } else {
          this.selectedStatus = this.status.slice()
        }
      })
    },
  },
  mounted() {
    this.loadLocalStatus();
  }
}
</script>

<style>

</style>